import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const PROMOTION_MENU: PermissionTableRowType = {
  name: '프로모션',
  key: 'PROMOTION_MANAGE',
  subRows: [
    {
      /**
       * 화면이 셋(타임라인·리스트·상세)이지만 **권한 subject 는 하나**다.
       * 그래서 행 이름은 특정 화면이 아니라 대상으로 둔다 — `스케줄 타임라인` 으로 두면
       * 리스트·상세가 이 체크박스에 달린 줄 모른다.
       * 표기는 다른 메뉴 관례(`기획전 관리`·`쿠폰 관리`·`태그 관리`)를 따른다.
       */
      name: '프로모션 관리',
      key: PERMISSION_SUBJECTS.PROMOTION_SCHEDULE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DELETE,
        PERMISSION_ACTIONS.DOWNLOAD_EXCEL,
      ],
      subRows: [
        {
          /**
           * 이 체크 하나가 화면 셋을 연다 — 타임라인 · 리스트 · 상세 (변경 이력 포함).
           * 권한 subject 가 하나뿐이라 화면별로 나눌 수 없다.
           *
           * 예전 이름 `타임라인 조회` 는 리스트·상세가 생기기 전 것이라 범위를 적어 둔다.
           * **엑셀 반출은 여기 없다** — 아래 별도 항목이다.
           */
          name: '리스트 조회 (타임라인·리스트·상세)',
          key: PERMISSION_SUBJECTS.PROMOTION_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '프로모션 등록',
          key: PERMISSION_SUBJECTS.PROMOTION_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '프로모션 편집',
          key: PERMISSION_SUBJECTS.PROMOTION_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '프로모션 삭제',
          key: PERMISSION_SUBJECTS.PROMOTION_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.DELETE],
        },
        {
          /**
           * 🔴 조회와 **별도 권한**이다 — 레포의 다른 반출 8곳이 전부 그렇다
           * (브랜드·주문·멀티채널·상품·판매자·유저·후기·정산).
           *
           * 화면에서 한 페이지를 보는 것과, 필터에 걸린 **전건을 파일로 빼내 메일로 보내는** 것은
           * 성격이 다르다. 백엔드도 `Action.DownloadExcel` 로 막는다.
           */
          name: '프로모션 엑셀 다운로드',
          key: PERMISSION_SUBJECTS.PROMOTION_SCHEDULE,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
  ],
};
